import {Component, Inject, OnInit} from '@angular/core';
import 'src/assets/js/morphext.min.js';

export interface ContactSalesData {
    username: string;
    partner: string;
    account: string;
    feedback_type: any;
    feedback_message: string;
    csat_score: string;

}

declare let $;
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeOldComponent implements OnInit {
    name: string;
    url: any;
    video: any = {id: 'qtTTQ5JU-A4'};
    baseUrl = 'https://www.youtube.com/embed/';
    constructor(public dialog: MatDialog,
                iconRegistry: MatIconRegistry, private Urlroute: ActivatedRoute,
                sanitizer: DomSanitizer) {
        iconRegistry.addSvgIcon(
            'api-generator',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/api-generator.svg'));

        iconRegistry.addSvgIcon(
            'security-compliance',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/security-compliance.svg'));
        iconRegistry.addSvgIcon(
            'data-backup',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/data-backup.svg'));
        iconRegistry.addSvgIcon(
            'dedicated-database',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/dedicated-database.svg'));
        iconRegistry.addSvgIcon(
            'metrics-dashboard',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/metrics-dashboard.svg'));
        iconRegistry.addSvgIcon(
            'multi-database',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/multi-database.svg'));
        iconRegistry.addSvgIcon(
            'secure-data-management',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/secure-data-management.svg'));
        iconRegistry.addSvgIcon(
            'secure-data',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/secure-data.svg'));
        iconRegistry.addSvgIcon(
            'security-operations',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/security-operations.svg'));
        iconRegistry.addSvgIcon(
            'server-monitoring',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/server-monitoring.svg'));
        iconRegistry.addSvgIcon(
            'web-security',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/web-security.svg'));

        this.url = sanitizer.bypassSecurityTrustResourceUrl(this.baseUrl + this.video.id);
    }

    openDialog() {
        const dialogRef = this.dialog.open(ContactSalesComponent, {
            data: '',
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(result => {
            // this.accept = result;
        });
    }

    ngOnInit() {
        $('#js-rotating').Morphext({
            animation: 'flipInX',
            separator: ',',
            speed: 3000,
            complete: function () {
            }
        });
    }

}

import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry, MatSnackBar} from '@angular/material';
import {ConfService} from '../conf.service';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

@Component({
    selector: 'feedback-dialog',
    templateUrl: './contactSales/sales.component.html',
    styleUrls: ['./contactSales/sales.component.css'],
})
export class ContactSalesComponent {

    constructor(
        private confPost: ConfService, public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<ContactSalesComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ContactSalesData) {
    }
    feedbackSchema = {
        username: '',
        email: '',
        phone: '',
        company: '',
        message: '',
    };


    onNoClick(): void {
        this.dialogRef.close();
    }

    sendSalesMail(result) {
        this.confPost.sendSalesQuery(this.feedbackSchema).subscribe(data => {
            this.platform.openSnackBar('Sales Query has been sent successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while sending Sales Query' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }
}
